import React, { FunctionComponent, SVGProps } from 'react';
import { useTheme } from 'styled-components';

export interface GeneralViewProps extends SVGProps<SVGSVGElement> {
  className?: string;
}

export const GeneralView: FunctionComponent<GeneralViewProps> = ({
  className,
}) => {
  const theme = useTheme();

  const getPathColor = (type?: 'bg' | 'highlighted') => {
    if (type === 'bg') {
      return theme.colors.box;
    }
    if (type === 'highlighted') {
      return theme.colors.upload;
    }

    return theme.colors.differentBackground;
  };

  return (
    <svg
      id="general-view"
      key={0}
      width={264}
      height={285}
      viewBox="0 0 264 285"
      className={className || ''}
    >
      <rect
        fill={getPathColor('bg')}
        opacity=".6"
        width="264"
        height="285"
        rx="10"
        ry="10"
      />
      <rect
        fill={getPathColor()}
        x="94"
        y="26"
        width="150"
        height="49"
        rx="4"
        ry="4"
      />
      <rect
        fill={getPathColor()}
        opacity=".67"
        x="94"
        y="83"
        width="71"
        height="71"
        rx="4"
        ry="4"
      />
      <rect
        fill={getPathColor()}
        opacity=".67"
        x="94"
        y="194"
        width="71"
        height="71"
        rx="4"
        ry="4"
      />
      <rect
        fill={getPathColor()}
        opacity=".67"
        x="94"
        y="162"
        width="150"
        height="24"
        rx="4"
        ry="4"
      />
      <rect
        fill={getPathColor('highlighted')}
        opacity=".5"
        x="20"
        y="26"
        width="58"
        height="100"
        rx="4"
        ry="4"
      />
      <rect
        fill={getPathColor('highlighted')}
        opacity=".5"
        x="20"
        y="130"
        width="58"
        height="10"
        rx="4"
        ry="4"
      />
      <rect
        fill={getPathColor('highlighted')}
        opacity=".5"
        x="20"
        y="144"
        width="58"
        height="10"
        rx="4"
        ry="4"
      />
      <rect
        fill={getPathColor()}
        opacity=".67"
        x="173"
        y="83"
        width="71"
        height="71"
        rx="4"
        ry="4"
      />
      <rect
        fill={getPathColor()}
        opacity=".67"
        x="173"
        y="194"
        width="71"
        height="71"
        rx="4"
        ry="4"
      />
    </svg>
  );
};

export default GeneralView;
